const POCKET_READY_TIMEOUT_MS = 8000;
const POCKET_READY_POLL_MS = 100;

/**
 * `pocket.latest.js` entra com `defer` no index.html, então `window.POCKET` pode
 * não existir quando um componente monta. Em vez de falhar em silêncio, espera.
 *
 * Compartilhado pelos dois fluxos (matrícula e ProUni) — por isso vive aqui, e
 * não dentro de um deles.
 */
export const waitForPocket = (timeoutMs = POCKET_READY_TIMEOUT_MS): Promise<boolean> =>
  new Promise(resolve => {
    if (window.POCKET) {
      resolve(true);
      return;
    }

    const startedAt = Date.now();
    const interval = window.setInterval(() => {
      if (window.POCKET) {
        window.clearInterval(interval);
        resolve(true);
      } else if (Date.now() - startedAt >= timeoutMs) {
        window.clearInterval(interval);
        resolve(false);
      }
    }, POCKET_READY_POLL_MS);
  });

export default { waitForPocket };
